import { useCallback, useState } from 'react';

/**
 * Manages the "sticky" state of favorited markets in market tables.
 *
 * When `isFavoritesSticky` is `true`, favorited markets are always at
 * the top of the list, even when sorting has been applied via another column.
 * The favorites themselves are also sorted by the applied column.
 */
export default function useIsFavoritesSticky() {
	const [isFavoritesSticky, setIsFavoritesSticky] = useState(true);

	const toggleIsFavoritesSticky = useCallback(() => {
		setIsFavoritesSticky((prev) => !prev);
	}, []);

	return { isFavoritesSticky, toggleIsFavoritesSticky };
}
